(function (angular, app) {
   "use strict";

   angular.module(app.modules.view.name).run([
       "$location", "$window"
       , app.modules.common.constants.appsettings
      , app.modules.common.services.eventbus
      , app.modules.member.services.accesscontrol
      , app.modules.common.constants.accesscontrolenum
      , app.modules.common.constants.rolecheckenum
      , function ($location, $window, ggAppSettings, ggCoreEventSvc, ggAccessControlSvc, accessControlType, roleCheckType) {
         
        
         // When we change routes, check user access & check features
         ggCoreEventSvc.subscribe("$routeChangeSuccess", function (event, next) {
            var updatePageFeatures = function () {
               // Features
               var features = app.modules.ui.features;

               features.showHeading = true;
               features.showBackgroundImg = true;
               features.bodyClass = "";

               // View Features
               if (next.features) {
                  // Is Navigation Displayed?
                  if (next.features.showHeading) {
                     features.showHeading = true;
                  } else {
                     features.showHeading = false;
                  }
                  // Is Background Displayed?
                  if (next.features.showBackgroundImg) {
                     features.showBackgroundImg = true;
                  } else {
                     features.showBackgroundImg = true; // Always on right now
                  }
                  // Boddy Class?
                  if (next.features.bodyClass) {
                     features.bodyClass = next.features.bodyClass;
                  }
               }

               // Broadcast a view change for UI
               ggCoreEventSvc.broadcast(app.modules.common.events.viewChange, features);
            }

            // no empty paths.
            if (next.originalPath == "") {
               next.originalPath = app.modules.view.routes.intro.path
            }

            // only need to validate if roles are preseent
            if (next.accessControl && next.accessControl.roles && next.accessControl.roles.length > 0) {
                  var accessGranted = ggAccessControlSvc.authorize(next.accessControl.roles, next.accessControl.roleCheckType);
                  if (accessGranted === accessControlType.authorized) {
                     $location.path(next.originalPath);
                     updatePageFeatures();
                  } else {
                     // Access denied.
                     $location.path(app.modules.view.routes.intro.path).replace();
                  }
            } else {
               if (next.isRedirect) {
                  $location.path(app.modules.view.routes.intro.path).replace();
                  updatePageFeatures();
               } else {
                  $location.path(next.originalPath);
                  updatePageFeatures();
               }
            }
         });


      }
   ]);
}(angular, app));